import { FormattedMessage } from 'react-intl';

import { PageWrapper } from 'modules/layout';
import config from 'config/index';

import PartnersForm from '../../containers/PartnersForm';

const PartnersPage = () => (
    <PageWrapper header={<FormattedMessage id="partners.title" values={{ event: config.app.name }} />}>
        <PartnersForm />
    </PageWrapper>
);

export default PartnersPage;
